import * as Sentry from "@sentry/react";

const getDsn = () => {
  const env = import.meta.env.MODE;
  if (env === "production") {
    return "https://ae9b4c9a795657413898f78ab1d59ea2@o4510184064548864.ingest.us.sentry.io/4510405923504128";
  }
  return "https://9f2b2ca25a22490c36f18a5abdd63cae@o4510184064548864.ingest.us.sentry.io/4510405928615936";
};

export function initSentry() {
  Sentry.init({
    dsn: getDsn(),
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
